<template>
  <div class="client-item-box j_client_item" :id="'nofixNav'+data.nofixNavId+'-'+data.nofixNavIndex" :class="classObj" :data-trackdata="tData">
    <div class="img-box" @click="imageSingleAction">
      <beast-image 
        class="img" 
        v-if="containerWidth"
        :lazy="true"
        :image="data.image"
        :containerWidth="containerWidth"
        :radius="imageRadius*ratio"
      />
      <div class="hot-areas" v-if="data.linkCheck === 'MULTI' && data.hotItems && data.hotItems.length">
        <div class="hot-area" 
          v-for="(item, index) in data.hotItems"
          :key="index"
          :style="{'width': `${item.area.w*ratio}px`, 'height': `${item.area.h*ratio}px`, 'left': `${item.area.x*ratio}px`, 'top': `${item.area.y*ratio}px`}"
          @click="hotAreaAction(item, index)">
        </div>
      </div>
      <div class="image-wrap" :style="imageWrapStyl" v-if="!data.linkCheck && positionArr && positionArr.length">
        <div 
          class="position-wrap"
          v-for="(p, index) in positionArr"
          :key="index"
          :style="{'width': p.width, 'left': p.left}"
          @click="imageAction(p)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getClientWidth, trackAction } from '../lib/util.js'
import { transformLink, normalSkip, getToMiniLink, getLinkPageData } from '@/link'

import beastImage from '@/components/image'

const clientWidth = getClientWidth()
const ratio = clientWidth/375

export default {
  name: 'article-image',
  // props: ['data'],
  props: ['data', 'pageType', 'miniEnv', 'isApp'],
  components: {
    beastImage
  },
  data () {
    return {
      ratio: ratio,
      positionFlag: false,
      position1Flag: false,
      containerWidth: 0,
      plr: 0,
      left: 0,
      left1: 0,
      positionArr: null,
      imageRadius: Number(this.data.radius || 0),
      tData: JSON.stringify(this.data.trackData || {})
    }
  },
  mounted() {
  },

  computed: {
    classObj () {
      let clsObj = {}
      let mbFlag = true
      let plrFlag = true
      let ptFlag = false
      if(this.data.noBottomGap) {
        mbFlag = false
      }
      if(this.data.fullWidth) {
        plrFlag = false
      }
      if(this.data.topGap) {
        ptFlag = true
      }

      // if(this.pageType === "article" || this.pageType === "index") {
      //   clsObj = {
      //     'mb15': mbFlag,
      //     'plr15': plrFlag,
      //     'pt15': ptFlag
      //   }
      // }

      if(this.pageType === "shop") {
        clsObj = {
          'pb20': true,
          'mb15': true,
          'plr25': plrFlag,
          'pt25': ptFlag
        }
      }
      
      return clsObj
    },

    imageWrapStyl () {
      let image = this.data.image
      let height = (this.containerWidth/image.width)*image.height
      let stylObj = {
        'height': `${height}px`,
        'margin-top': `${-height}px`
      }
      if(this.data.qrcodeFlag) {
        stylObj = {
          'height': `${height}px`,
          'margin-top': `${-height}px`,
          'z-index': -1
        }
      }
      return stylObj
    },
  },

  created() {
    this.getContainerWidth()
    if(!this.data.hotItems || !this.data.hotItems.length) {
      this.checkPosition()
    }
  },

  methods: {
    getContainerWidth () {
      let cw;
      let pageWidth = 375
      const {
        pl,
        pr
      } = this.data.paddingData

      if(this.data.fullWidth) {
        cw = clientWidth
      } else {
        if(this.pageType === "article") {
          // this.plr = 30
          this.plr = pl+pr
        }
        if(this.pageType === "shop-story") {
          this.plr = 80
        }
        if(this.pageType === "shop") {
          this.plr = 50
        }
        pageWidth -= this.plr
        cw = (pageWidth/375)*clientWidth
      }
      this.containerWidth = cw
    },

    checkPosition () {
      const position = this.data.position
      const position1 = this.data.position1
      // console.log(position, position1, "position-position1")
      if(position && position>0 && position<365) {
        this.positionFlag = true
        this.left = (position/375)*this.containerWidth
      }
      if(position1 && position1>0 && position1<365) {
        this.position1Flag = true
        this.left1 = (position1/375)*this.containerWidth
      }

      let positionArr = []
      if(!this.positionFlag && !this.position1Flag) {
        positionArr.push({
          width: `${this.containerWidth}px`,
          left: `0px`,
          link: this.data.link,
          title: this.data.title,
          toMiniProgram: this.data.toMiniProgram
        })
      } else if(this.positionFlag && !this.position1Flag) {
        positionArr.push({
          width: `${this.left}px`,
          left: `0px`,
          link: this.data.link,
          title: this.data.title,
          toMiniProgram: this.data.toMiniProgram
        })
        positionArr.push({
          width: `${this.containerWidth-this.left}px`,
          left: `${this.left}px`,
          link: this.data.link2,
          title: this.data.title2,
          toMiniProgram: this.data.toMiniProgram2
        })
      } else if(!this.positionFlag && this.position1Flag) {
        positionArr.push({
          width: `${this.left1}px`,
          left: `0px`,
          link: this.data.link2,
          title: this.data.title2,
          toMiniProgram: this.data.toMiniProgram2
        })
        positionArr.push({
          width: `${this.containerWidth-this.left1}px`,
          left: `${this.left1}px`,
          link: this.data.link3,
          title: this.data.title3,
          toMiniProgram: this.data.toMiniProgram3
        })
      } else if(this.positionFlag && this.position1Flag) {
        positionArr.push({
          width: `${this.left}px`,
          left: `0px`,
          link: this.data.link,
          title: this.data.title,
          toMiniProgram: this.data.toMiniProgram
        })
        positionArr.push({
          width: `${this.left1-this.left}px`,
          left: `${this.left}px`,
          link: this.data.link2,
          title: this.data.title2,
          toMiniProgram: this.data.toMiniProgram2
        })
        positionArr.push({
          width: `${this.containerWidth-this.left1}px`,
          left: `${this.left1}px`,
          link: this.data.link3,
          title: this.data.title3,
          toMiniProgram: this.data.toMiniProgram3
        })
      }
      // console.log(positionArr, "positionArr")
      this.positionArr = positionArr
    },

    imageAction (p) {
      // this.$alert("test click")
      const trackData = this.data.trackData
      if(!this.positionFlag && !this.position1Flag) {
        this.skipLink({
          link: this.data.link,
          title: this.data.title,
          trackData,
          toMiniProgram: this.data.toMiniProgram
        })
      } else {
        this.skipLink({
          link: p.link,
          title: p.title,
          trackData,
          toMiniProgram: p.toMiniProgram
        })
      }
    },

    imageSingleAction () {
      if(this.data.linkCheck === 'SINGLE') {
        this.skipLink({
          link: this.data.link,
          title: '',
          trackData: this.data.trackData,
          toMiniProgram: this.data.toMiniProgram
        })
      }
    },

    hotAreaAction (item, index) {
      const trackData = this.data.trackData
      trackData.module_number = index-0+1
      trackData.operation_name = item.trackTitle || ''
      trackData.operation_type = item.trackServiceType || ''
      this.skipLink({
        link: item.link,
        title: '',
        trackData,
        toMiniProgram: item.toMiniProgram
      })
    },

    skipLink ({link, title, trackData, toMiniProgram}) {
      // console.log(link, "link")
      if(!link || link.type === 'none') {
        return
      }

      let myLink = ''
      let toMiniFlag = false
      if(this.isApp && toMiniProgram) {//app环境 且 在app打开小程序页面
        myLink = getToMiniLink({
                link,
                title
              })
      }
      if(myLink) {
        toMiniFlag = true
      }
      if(!myLink) {
        myLink = transformLink({
                link,
                title,
                isMini: this.miniEnv
              })
      }

      trackAction({
        trackData,
        pageObj: getLinkPageData({link, title})
      })

      normalSkip({
        link: myLink,
        isMini: this.miniEnv,
        toMiniProgram: toMiniFlag
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// image.vue?bbd26c8c